import { useSelector } from "react-redux";
import { applyMiddleware, combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import thunk from "redux-thunk";
import { backendAddressReducer } from "./backendAddress/reducer";
import { customizationReducer } from "./customization/reducer";
import { feedbackDisplayedReducer } from "./feedbackDisplayed/reducer";
import { languageReducer } from "./language/reducer";
import { loadingBarsReducer } from "./loadingBars/reducer";
import { messageReducer } from "./message/reducer";
import { peerReviewsReducer } from "./peerReviews/reducer";
import { quizReducer } from "./quiz/reducer";
import { quizAnswerReducer } from "./quizAnswer/reducer";
import { userReducer } from "./user/reducer";
import { receivedReviewsReducer } from "./receivedReviews/reducer";
import * as backendAddressActions from "./backendAddress/actions";
import * as customizationActions from "./customization/actions";
import * as feedbackDisplayedActions from "./feedbackDisplayed/actions";
import * as languageActions from "./language/actions";
import * as loadingBarsActions from "./loadingBars/actions";
import * as messageActions from "./message/actions";
import * as quizActions from "./quiz/actions";
import * as quizAnswerActions from "./quizAnswer/actions";
import * as userActions from "./user/actions";
import * as PeerReviewsActions from "./peerReviews/actions";
import * as receivedReviewsActions from "./receivedReviews/actions";
var rootReducerImpl = combineReducers({
  backendAddress: backendAddressReducer,
  customization: customizationReducer,
  feedbackDisplayed: feedbackDisplayedReducer,
  language: languageReducer,
  loadingBars: loadingBarsReducer,
  message: messageReducer,
  peerReviews: peerReviewsReducer,
  quiz: quizReducer,
  quizAnswer: quizAnswerReducer,
  receivedReviews: receivedReviewsReducer,
  user: userReducer
});

var rootReducer = function rootReducer(state, action) {
  if (action.type === "CLEAR") {
    var bestState = undefined;
    return bestState;
  }

  return rootReducerImpl(state, action);
};

export var rootAction = {
  backendAction: backendAddressActions,
  customization: customizationActions,
  feedbackDisplayed: feedbackDisplayedActions,
  language: languageActions,
  loadingBars: loadingBarsActions,
  peerReviews: PeerReviewsActions,
  message: messageActions,
  quiz: quizActions,
  quizAnswer: quizAnswerActions,
  user: userActions,
  receivedReviews: receivedReviewsActions
};
var idToStoreCache = new Map();

var createStoreInstance = function createStoreInstance(id) {
  var cached = idToStoreCache.get(id);

  if (cached) {
    return cached;
  }

  var store = createStoreCreator();
  idToStoreCache.set(id, store);
  return store;
};

var createStoreCreator = function createStoreCreator() {
  return createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)));
};

export var useTypedSelector = useSelector;
export default createStoreInstance;